import clsx from "clsx";
import ClippedText from "components/clipped-text";
import Heading from "components/heading";
import ImagePlaceholder from "components/image-placeholder";
import ImageRenderer from "components/rich-text/components/image";
import { format, parse } from "date-fns";
import { useRouter } from "next/router";

import { ResourceItem } from "./types";

type ListCardProps = ResourceItem & {
  className?: string;
};

const CardItem = ({ type, postedDate, title, slug, image, className }: ListCardProps) => {
  const router = useRouter();
  const filterByType = e => {
    e.stopPropagation();
    e.preventDefault();
    router.push(`/resources?type=${type.value}`);
  };
  return (
    <a href={`/resources/${slug}`} className="p-0 mt-2 block flex-1 group text-left">
      <div
        key={title}
        className={clsx(
          className,
          "h-full flex flex-col overflow-hidden rounded-xl shadow-lg transition-all border border-gray-200 hover:border-gray-300 hover:shadow-xl"
        )}
      >
        <div className="flex shrink-0 h-36 min-w-0 relative">
          {image ? (
            <ImageRenderer
              value={image}
              className="w-full h-full"
              imageClassName="object-center object-cover crispImage"
              layout="fill"
            />
          ) : (
            <ImagePlaceholder />
          )}
        </div>
        <div className="flex flex-1 flex-col justify-between bg-white p-4 md:p-6">
          <div className="flex gap-x-2 flex-wrap">
            <button
              onClick={filterByType}
              className="hover:underline p-0 text-sm font-bold text-primary tracking-wide"
              title={`Filter by ${type.label}`}
              aria-label={`Filter by ${type.label}`}
            >
              {type.value.toUpperCase()}
            </button>
            <time dateTime={postedDate} className="text-sm text-gray-400 w-full sm:w-auto">
              {format(parse(postedDate, "yyyy-MM-dd", new Date()), "MMMM dd, yyyy")}
            </time>
          </div>
          <Heading className="text-gray-900 group-hover:text-primary transition-colors mt-2 block flex-1" tag="h5">
            <ClippedText text={title} />
          </Heading>
        </div>
      </div>
    </a>
  );
};

export default CardItem;
